import { Color } from "config/colors";
import styled from "styled-components";

interface SearchContainerProps {
  hasError?: boolean;
}

interface SearchInputProps {
  fontSize?: string;
  hasError?: boolean;
  hasButton?: boolean;
}

export const SearchContainer = styled.div<SearchContainerProps>`
  display: flex;
  align-items: stretch;
  position: relative;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: white;
  height: 35px;
  overflow: hidden; // Viktigt för att knappen ska se integrerad ut

  &:focus-within {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  }

  ${(props) =>
    props.hasError &&
    `
    border-color: #dc3545;
    &:focus-within {
      border-color: #dc3545;
      box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
    }
  `}
`;

export const SearchInput = styled.input<SearchInputProps>`
  flex: 1;
  border: none;
  outline: none;
  padding: 12px 16px;
  padding-left: ${(props) => (props.hasButton ? "16px" : "44px")};
  padding-right: ${(props) => (props.hasButton ? "0" : "16px")};
  font-size: ${(props) => props.fontSize || "14px"};
  background: transparent;
  border-radius: ${(props) => (props.hasButton ? "8px 0 0 8px" : "8px")};

  &::placeholder {
    color: #6c757d;
  }

  &:disabled {
    background-color: #f8f9fa;
    cursor: not-allowed;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  color: #6c757d;
  pointer-events: none;
  z-index: 1;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SearchButton = styled.button`
  background-color: ${Color.DarkGrey};
  color: white;
  border: none;
  border-radius: 0 8px 8px 0;
  padding: 0 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid rgba(255, 255, 255, 0.2);

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background-color: ${Color.LightGrey03};
  }

  &:focus {
    outline: none;
    background-color: ${Color.DarkGrey};
  }

  &:active {
    background-color: ${Color.DarkGrey};
    transform: scale(0.98);
  }
`;
